import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container10">
      <Helmet>
        <title>Contact Vlad Butucariu - Senior Product Designer</title>
        <meta
          name="description"
          content="Contact Rotterdam-based senior product designer Vlad Butucariu about product design roles and selected collaborations."
        />
        <meta
          property="og:title"
          content="Contact Vlad Butucariu - Senior Product Designer"
        />
        <meta
          property="og:description"
          content="Get in touch about senior product design roles, embedded product work, and selected collaborations."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/contact" />
        <meta property="og:url" content="https://vladbutucariu.com/contact" />
      </Helmet>
      <div className="contact-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="contact-thq-top-section-elm">
          <div className="contact-thq-video-div-elm1">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="contact-video1"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="contact-thq-video-mobile-elm1"
            ></video>
          </div>
          <div className="contact-thq-section-elm">
            <div className="contact-thq-color-wrapper-elm">
              <div className="contact-container11">
                <div className="contact-container12">
                  <img
                    alt="image"
                    src="/Images/tickerpurple.200.svg"
                    className="contact-image"
                  />
                  <div className="contact-container13">
                    <h1 className="contact-text10">// CONTACT</h1>
                    <div className="contact-container14">
                      <span className="contact-text11">Rotterdam, NL</span>
                      <span className="contact-text12">CET / remote</span>
                    </div>
                  </div>
                </div>
                <div className="contact-container15">
                  <p className="contact-text13">
                    <span>
                      For senior product design roles, embedded product work,
                      or selected collaborations, send me a short note about
                      what you&apos;re building and where design can make a
                      difference.
                    </span>
                    <br></br>
                  </p>
                  <div className="contact-container16">
                    <div className="contact-container17">
                      <div className="contact-container18">
                        <h2 className="contact-text16">
                          <span>Product Design:</span>
                          <br></br>
                        </h2>
                        <a
                          href="mailto:vlad@irreversible.cc?subject=Hi Vlad"
                          className="contact-link1"
                        >
                          <h2 className="contact-text19">
                            <span>
                              vlad@irreversible.cc
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <br></br>
                          </h2>
                        </a>
                      </div>
                      <span className="contact-text22">
                        For roles, product collaborations, and complex design
                        challenges.
                      </span>
                    </div>
                    <div className="contact-container21">
                      <div className="contact-container22">
                        <h2 className="contact-text28">Social:</h2>
                        <a
                          href="https://twitter.com/irreversiblelab"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="contact-link3"
                        >
                          <h2 className="contact-text29">
                            X / Twitter
                          </h2>
                        </a>
                      </div>
                      <span className="contact-text30">
                        Follow the work in progress.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-thq-video-div-elm2">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="contact-video2"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="contact-video3"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="contact-thq-video-mobile-elm2"
            ></video>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Contact
